<template>
  <ul class="checkboxes-list">
    <li
      class="checkbox-label"
      v-for="(step, index) in steps"
      :key="index"
    >
      <input
        type="checkbox"
        :id="'question-' + index"
        :value="step"
        v-model="selected"
        @change="handleCheck"
      />
      <label class="label">{{ step.text }}</label>
    </li>
  </ul>
</template>

<script>
import { isEqual, orderBy } from 'lodash';

export default {
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    roundIndex: Number,
    onCheck: {
      type: Function,
      default: () => () => {}
    }
  },

  data() {
    return {
      selected: [],
      correctAnswers: this.steps.filter(i => i.isCorrectAnswer)
    };
  },
  methods: {
    handleCheck() {
      if (this.selected.length === 0) {
        this.onCheck('multiSelect', this.roundIndex, this.selected);
        return;
      }
      const invalidMultiSelect = !isEqual(
        orderBy(this.correctAnswers, 'text'),
        orderBy(this.selected, 'text')
      );

      if (invalidMultiSelect) {
        const answers = [...this.selected];
        this.correctAnswers.forEach(({ text }) => {
          const found = answers.find(el => el.text === text);
          if (!found) {
            answers.push({ text, isCorrectAnswer: false });
          }
        });
        this.onCheck('multiSelect', this.roundIndex, answers);
      } else {
        this.onCheck('multiSelect', this.roundIndex, this.selected);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkboxes-list {
  padding-left: 7%;
  flex: 1;

  li {
    font-weight: 400;
    list-style: none;
  }

  .checkbox-label {
    margin: 20px;
    font-size: 30px;
    label {
      padding-left: 30px;
    }
  }
}
.checkboxes-list input[type="checkbox"] {
  opacity: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.checkboxes-list label {
  position: relative;
}

.checkboxes-list label::before {
  content: "";
  position: absolute;
  top: 6px;
  left: -30px;
  width: 25px;
  height: 25px;
  border-radius: 1px;
  border: 1px solid black;
  pointer-events: none;
  text-align: center;
  color: #000;
}

.checkboxes-list input[type="checkbox"]:checked + label:before {
  content: "\2713";
  font-size: 21px;
  font-weight: bold;
}
</style>
